import React from 'react';
import { TabPane } from 'reactstrap';
import { TABS } from '../..';
import { AutoSizer, List } from 'react-virtualized';
import { verifyRoles } from 'components/Authentication/VerifyRoles';
import { CheckboxChat } from '../../styled';
import QueueTag from '../QueueTag';

export const TabChatsInAttendance = ({
  chats = [],
  queues,
  idNameTags,
  handleCheck,
  answerConversation,
  selectedConversations
}) => {
  return (
    <TabPane
      tabId={TABS.IN_ATTENDANCE}
      style={{
        width: '100%',
        height: '94%'
      }}
    >
      <AutoSizer>
        {({ width, height }) => (
          <List
            style={{
              scrollbarWidth: 'thin',
              margin: '0px',
              padding: '0px'
            }}
            width={width}
            height={height}
            rowHeight={140}
            rowCount={chats?.length || 0}
            rowGetter={({ index }) => chats[index] || {}}
            rowRenderer={({ key, index, style }) => {
              const id = chats[index]?.id || chats[index]?._id;
              return (
                <div key={key} style={style}>
                  {verifyRoles(['CHAT_MULTIPLE_TRANSFER']) && (
                    <CheckboxChat
                      checked={selectedConversations.includes(id)}
                      onClick={(event) => {
                        handleCheck(event, id);
                      }}
                      type="checkbox"
                    />
                  )}

                  <QueueTag
                    checked={selectedConversations.includes(id)}
                    key={key}
                    style={style}
                    conversation={chats[index]}
                    idNameTags={idNameTags}
                    allQueues={queues}
                    functionAnswerConversation={answerConversation}
                  />
                </div>
              );
            }}
          />
        )}
      </AutoSizer>
    </TabPane>
  );
};
